module.exports = __webpack_public_path__ + "img/sphere07-graph.8e3edc9c.png";